import { render, staticRenderFns } from "./OnboardingSecondStep.vue?vue&type=template&id=442b9c17&scoped=true"
import script from "./OnboardingSecondStep.vue?vue&type=script&lang=js"
export * from "./OnboardingSecondStep.vue?vue&type=script&lang=js"
import style0 from "./OnboardingSecondStep.vue?vue&type=style&index=0&id=442b9c17&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442b9c17",
  null
  
)

export default component.exports